<template>
  <v-layout>
    <v-dialog
      v-model="showNewCitizenDialog"
      width="700"
    >
      <v-card>
        <v-card-title class="headline grey lighten-4">
          Novo cliente
        </v-card-title>
        <v-container>
            <v-form v-model="valid">
              <v-layout wrap>
                <v-flex xs12 class="px-2">
                  <label for="name">Nome Completo</label>
                  <v-text-field
                    type="text"
                    v-model="name"
                    :rules="[validationRules.required]"
                  />
                </v-flex>
                <v-flex xs4 class="px-2">
                  <label for="cpf">CPF</label>
                  <v-text-field
                    v-model="cpf"
                    mask="###.###.###-##"
                    :rules="[validationRules.required, validationRules.cpf]"
                  />
                </v-flex>
                <v-flex xs4 class="px-2">
                  <label for="email">Email</label>
                  <v-text-field
                    type="email"
                    v-model="email"
                    :rules="[validationRules.required, validationRules.email]"
                  />
                </v-flex>
                <v-flex xs4 class="px-2">
                  <label for="telephone">Telefone</label>
                  <v-text-field
                    v-model="telephone"
                    mask="(##)####-####"
                    :rules="[validationRules.required]"
                  />
                </v-flex>
              </v-layout>
            </v-form>
        </v-container>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn flat @click="$emit('newCitizenCallback', false)">
              Cancelar
            </v-btn>
            <v-btn
              flat
              color="blue"
              @click="createNewCitizen()"
              :disabled="!valid"
            >
              Confirmar
            </v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import citizensService from '@/services/CitizensService';
import validationRules from '@/mixins/validation-rules';

export default {
  name: 'NewCitizenDialog',
  props: {
    showNewCitizenDialog: {
      default: false,
    },
  },
  data() {
    return {
      name: '',
      cpf: '',
      email: '',
      telephone: '',
      validationRules,
      valid: false,
    };
  },
  methods: {
    createNewCitizen() {
      const citizen = {
        name: this.name,
        cpf: this.cpf,
        email: this.email,
        telephone: this.telephone,
      };

      citizensService.createCitizen({ citizen })
        .then(({ data }) => {
          this.$store.dispatch('toggleSnackbar', {
            show: true,
            color: 'success',
            message: 'Novo Cliente cadastrado com sucesso',
            button: { show: true, text: 'Fechar', message: '' },
            timeout: 6000,
          });
          this.$emit('newCitizenCallback', this.name);
        })
        .catch(({response}) => {
          this.$store.dispatch('toggleSnackbar', {
            show: true,
            color: 'error',
            message: response.join(', ' ),
            messageIcon: 'mdi-alert-outline',
            button: { show: true, text: 'Fechar', message: '' },
            timeout: 6000,
          });
          // this.$emit('newCitizenCallback', false);
        })
    },
  },
};
</script>

<style scoped>
  .custom-message {
    font-size: 1.5em;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/folder/interested/new/NewCitizenDialog.vue